import React from 'react';
import {
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Paper,
  Typography,
  IconButton,
  Box,
  Divider,
} from '@mui/material';
import { Add, Delete } from '@mui/icons-material';
import { FormTemplate } from '../../../../shared/types/appTypes';

interface TemplateSidebarProps {
  templates: FormTemplate[];
  selectedId: string | null;
  onSelect: (template: FormTemplate) => void;
  onNew: () => void;
  onDelete: (id: string) => void;
  loading?: boolean;
}

const TemplateSidebar: React.FC<TemplateSidebarProps> = ({
  templates,
  selectedId,
  onSelect,
  onNew,
  onDelete,
  loading,
}) => {
  return (
    <Paper sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Box
        sx={{
          p: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Typography variant="subtitle1" fontWeight={600}>
          Form Templates
        </Typography>
        <IconButton color="primary" onClick={onNew} size="small">
          <Add />
        </IconButton>
      </Box>
      <Divider />
      <List sx={{ flex: 1, overflow: 'auto', py: 0 }}>
        {templates.length === 0 && !loading && (
          <ListItem>
            <ListItemText
              secondary="No templates yet"
              sx={{ textAlign: 'center' }}
            />
          </ListItem>
        )}
        {templates.map((template) => (
          <ListItem
            key={template.id}
            disablePadding
            secondaryAction={
              <IconButton
                edge="end"
                size="small"
                onClick={(e) => {
                  e.stopPropagation();
                  onDelete(template.id);
                }}
              >
                <Delete fontSize="small" />
              </IconButton>
            }
          >
            <ListItemButton
              selected={selectedId === template.id}
              onClick={() => onSelect(template)}
            >
              <ListItemText
                primary={template.name}
                secondary={`${template.fields?.length || 0} fields`}
                primaryTypographyProps={{
                  noWrap: true,
                  fontWeight: selectedId === template.id ? 600 : 400,
                }}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Paper>
  );
};

export default TemplateSidebar;
